import PropTypes from 'prop-types';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
} from '../../../../config/dataConfig/FJGenerateData';
import FJLocalStore from '../../../../store/FJLocalStore';

import styles from './FJTextToImageImageUploader.module.less';
import FJMultipleImageUploader from '../../../../common/components/FJMultipleImageUploader/FJMultipleImageUploader';

function FJTextToImageImageUploader({
    onUpload,
    onOpenMediaLibrary,
    uploadImageInfo,
    uploadStatus,
    setIsDraggingFile,
    isDraggingFile,
    onDelete,
    uploadImages,
    handleUploadMultiple,
    handleRemoveImage,
    supportImageReferenceNum,
}) {
    const _renderTitle = () => {
        return (
            <div className={styles.text_to_image_uploader_title}>
                {FJLocalStore._('reference-image')}
                <div className={styles.optional}>{FJLocalStore._('optional')}</div>
            </div>
        );
    };
    const _renderUploadComponent = () => {
        return supportImageReferenceNum > 1 ? (
            <FJMultipleImageUploader
                inputImages={uploadImages}
                renderTitle={_renderTitle}
                onUploadMultiple={handleUploadMultiple}
                onRemoveImage={handleRemoveImage}
                isDraggingFile={isDraggingFile}
                setIsDraggingFile={setIsDraggingFile}
                acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                openMediaLibrary={onOpenMediaLibrary}
                maxImages={supportImageReferenceNum}
                titleStyle={{ marginTop: '0px', marginBottom: '0' }}
            />
        ) : (
            <>
                {_renderTitle()}
                <FJImageInput
                    uploadImg={onUpload}
                    uploadImageInfo={uploadImageInfo}
                    uploadStatus={uploadStatus}
                    acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                    openMediaLibrary={onOpenMediaLibrary}
                    uploadText='upload-image'
                    setIsDraggingFile={setIsDraggingFile}
                    isDraggingFile={isDraggingFile}
                    isDelete
                    onDelete={onDelete}
                    uploadImages={uploadImages}
                />
            </>
        );
    };
    return <div className={styles.text_to_image_uploader}>{_renderUploadComponent()}</div>;
}

FJTextToImageImageUploader.propTypes = {
    onUpload: PropTypes.func,
    onOpenMediaLibrary: PropTypes.func,
    uploadImageInfo: PropTypes.object,
    uploadStatus: PropTypes.string,
    setIsDraggingFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    onDelete: PropTypes.func,
    uploadImages: PropTypes.array,
    handleUploadMultiple: PropTypes.func,
    handleRemoveImage: PropTypes.func,
    handleOpenMediaLibrary: PropTypes.func,
    supportImageReferenceNum: PropTypes.number,
    titleStyle: PropTypes.object,
};

export default FJTextToImageImageUploader;
